/**
 * Per-tab boot: open the holder stream first, then chrome GETs.
 * Hard refresh and new tabs wait for stream open. SPA navigation reuses an
 * already-open stream. Hung HTTP/2 connects abort after a short header timeout
 * and retry; the connecting screen does not skip the gate.
 */

const STREAM_OPEN_LISTENERS = new Set<() => void>();

let holderStreamHttpOpen = false;

export function isHubSessionLiveStreamOpen(): boolean {
  return holderStreamHttpOpen;
}

export function notifyHubSessionLiveStreamOpen(): void {
  if (holderStreamHttpOpen) {
    return;
  }
  holderStreamHttpOpen = true;
  for (const listener of STREAM_OPEN_LISTENERS) {
    listener();
  }
}

export function onHubSessionLiveStreamOpen(listener: () => void): () => void {
  if (holderStreamHttpOpen) {
    listener();
  }
  STREAM_OPEN_LISTENERS.add(listener);
  return () => {
    STREAM_OPEN_LISTENERS.delete(listener);
  };
}

/** Call when this tab fully tears down the holder stream (logout), not on reconnect. */
export function clearHubSessionLiveStreamOpen(): void {
  holderStreamHttpOpen = false;
}

export function resetHubSessionLiveListenersForTests(): void {
  STREAM_OPEN_LISTENERS.clear();
  holderStreamHttpOpen = false;
}
